// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rO4uP","label":"styles_label__QI8KU"};